import Care from '../../pages/Care/Care'
import Compare from '../../pages/Compare/Compare'
import Gallery from '../../pages/Gallery/Gallery'
import Home from '../../pages/Home/Home'
import Order from '../../pages/Order/Order'
import Pricelist from '../../pages/Pricelist/Pricelist'

export const navigation = [
    {
        href: '/',
        title: 'Drippy Rugs',
        showNav: true,
        component: <Home />,
    },
    {
        href: '/pricelist',
        title: 'Ceník',
        showNav: true,
        component: <Pricelist />,
    },
    {
        href: '/care',
        title: 'Péče o kobereček',
        showNav: true,
        component: <Care />,
    },
    {
        href: '/gallery',
        title: 'Galerie',
        showNav: true,
        component: <Gallery />,
    },
    {
        href: '/order',
        title: 'Jak objednat',
        showNav: true,
        component: <Order />,
    },
    {
        href: '/compare',
        title: 'Porovnání',
        showNav: false,
        component: <Compare />,
    },
]
